import React, { createContext, Dispatch, useState } from 'react';

export const WarningsContext = createContext<[boolean, Dispatch<any>]>([{} as any, () => null]);

export const WarningsProvider: React.FunctionComponent<any> = ({ children }) => {
    const [showWarning, setShowWarning] = useState(false);

    return <WarningsContext.Provider value={[showWarning, setShowWarning]}>{children}</WarningsContext.Provider>;
};
